/**
 * Empty state for a campus whose order grouping dimension has no
 * configured groups yet (no vocabulary values for its order dimension).
 *
 * Order groups are provisioned by the Ordo team (customers console →
 * enrollment setup / student import), not self-serve in
 * /settings/my-school — so unlike the age-group empty state, the action
 * here is "contact support", not a settings deep-link.
 */

import { EmptyState } from '@ordo/ui/empty-state'
import { Users } from 'lucide-react'
import type { ReactElement } from 'react'

import { SupportEmailButton } from '../../../lib/support'

export function OrderGroupsEmptyState(): ReactElement {
  return (
    <EmptyState
      icon={<Users className="h-10 w-10" />}
      title="No order groups set up yet"
      description="This school orders per group (homeroom, grade, teacher, or lunch period), but no groups are configured for the current term. The Ordo team sets up groups and students during onboarding — reach out and we'll get them loaded."
      action={<SupportEmailButton subject="Order group setup — Orders" />}
      padding="lg"
    />
  )
}
